import { FC } from 'react';
import FontBody1 from '../../../../components/fonts/font-body1/font-body1';
import { FONT_COLOR } from '../../../../components/fonts/font-props';
import { Checkbox } from '../../../../components/inputs/checkbox/checkbox';
import useDashboardTranslation from '../../../../dashboard-translation/hooks/dashboard-translation-hook';
import './terms-acceptance-shared.scss';

const TRANSLATION_SCOPE = 'dashboard-onboarding';

export interface ITermsAcceptanceModalContentProps {
    termsContent: string;
    isChecked: boolean;
    isSubmitting: boolean;
    onCheckedChange: (checked: boolean) => void;
}

const TermsAcceptanceModalContent: FC<ITermsAcceptanceModalContentProps> = ({
    termsContent,
    isChecked,
    isSubmitting,
    onCheckedChange,
}) => {
    const { getTranslation } = useDashboardTranslation();

    return (
        <>
            <div className="terms-acceptance-terms-box" aria-label="Terms and conditions">
                <pre className="terms-acceptance-terms-text">{termsContent}</pre>
            </div>
            <div className="terms-acceptance-checkbox">
                <Checkbox
                    label={
                        <FontBody1 color={FONT_COLOR.NEUTRAL11_MENU}>
                            {getTranslation('TERMS_ACCEPTANCE_CHECKBOX_LABEL', TRANSLATION_SCOPE)}
                        </FontBody1>
                    }
                    checked={isChecked}
                    onChange={onCheckedChange}
                    disabled={isSubmitting}
                />
            </div>
        </>
    );
};

export default TermsAcceptanceModalContent;
